<div class="d-flex flex-wrap gap-1">
  @for (model of models; track model) {
        <div class="btn p-2 d-flex flex-column align-items-center justify-content-center rounded" [ngClass]="{ 
                'selected-model-button': selectedID == model.id, 
                'border border enlarged shadow': hoveredID == model.id,
                'disabled': !isOwner(model) && !inBuilder 
            }" style="width:fit-content" (mouseover)="setHovered(model)" (mouseout)="setHovered(undefined)"
      (click)="selectModel(model, $event)">
      <!-- Thumbnail -->
      <div class="thumbnail border rounded-circle d-flex align-items-center justify-content-center">
        @if (model.thumbnail) {
          <img [src]="model.thumbnail" style="display: block; height: 250%">
        }
        @if (!model.thumbnail) {
          <i class="fa-solid fa-cube fa-lg"></i>
        }
      </div>
      <!-- Name -->
      <div class="model-title pt-1" style="font-size:0.7rem">
        {{ model.name }}
      </div>
    </div>
  }
</div>